import type { ReactNode } from 'react';

import { createContext, useContext, useState, useMemo } from 'react';

type QuickViewContextType = {
  isQuickViewOpen: boolean;
  setIsQuickViewOpen: (isOpen: boolean) => void;
};

const QuickViewContext = createContext<QuickViewContextType>({
  isQuickViewOpen: false,
  setIsQuickViewOpen: () => {},
});

export const useQuickViewContext = () => useContext(QuickViewContext);

export const QuickViewContextProvider = ({ children }: { children: ReactNode }) => {
  const [isQuickViewOpen, setIsQuickViewOpen] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      isQuickViewOpen,
      setIsQuickViewOpen,
    }),
    [isQuickViewOpen]
  );

  return <QuickViewContext.Provider value={value}>{children}</QuickViewContext.Provider>;
};
